var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item"},[(_vm.name)?_c('div',{staticClass:"heading"},[_c('span',{staticClass:"title"},[(_vm.number)?_c('b',{staticClass:"badge badge-blue letter m-r-s"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_vm._v(" "+_vm._s(_vm.name)+" ")])]):_vm._e(),_c('div',{staticClass:"options"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }